import { cancelOptimize } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/optimize/index.tsx';
import { reportTimeToInteractive } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/time-to-interactive/index.tsx';
import type { ReportTimeToInteractivePayload } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/time-to-interactive/types.tsx';
import {
	OPTIMIZING,
	OPTIMIZED,
	type Mode,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/app/types.tsx';
import {
	viewDependencies,
	clickDependencyLine,
	clickDependencyCard,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/actions.tsx';
import {
	setIssueInFocus,
	setIssueFilter,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/filters/actions.tsx';
import { setReportStatus } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/report-state/actions.tsx';
import type { ReportStatus } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/report-state/types.tsx';
import { setStagePositionAndScale } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/stage-position-scale/actions.tsx';
import type { StagePosAndScale } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/main/tabs/dependencies/stage-position-scale/types.tsx';
import type { MapDispatchToPropsSimple } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux.tsx';
import type { DispatchProps } from './types.tsx';

const mapDispatchToProps: MapDispatchToPropsSimple<DispatchProps> = (dispatch) => ({
	reportTimeToInteractive: (payload: ReportTimeToInteractivePayload) =>
		dispatch(reportTimeToInteractive(payload)),
	focusIssueLink: (issueId?: string | null) => {
		dispatch(setIssueInFocus(issueId));
	},
	onDependenciesView: (mode: Mode) => {
		dispatch(viewDependencies());
		if (mode === OPTIMIZING || mode === OPTIMIZED) {
			dispatch(cancelOptimize());
		}
	},
	onLineClick: (linksLength: number) => {
		dispatch(clickDependencyLine(linksLength));
	},
	onCardClick: (id: string) => {
		dispatch(clickDependencyCard(id));
	},
	setIssueFilter: (issueId: string | null) => {
		dispatch(setIssueFilter(issueId));
	},
	setStagePositionAndScale: (posScale: StagePosAndScale) => {
		dispatch(setStagePositionAndScale(posScale));
	},
	setReportStatus: (status: ReportStatus) => {
		dispatch(setReportStatus(status));
	},
});

export default mapDispatchToProps;
